import React, { MouseEventHandler } from "react";

import { formatNumber } from "utils";

import { FieldListField } from "models";

import { Card, Checkbox, Icon, MapStatic } from "components";

type FieldListCardProps = {
  field: FieldListField;
  isSelected: boolean;
  onSelectionChange: MouseEventHandler;
  dataTestId?: string;
  disabled?: boolean;
};

export const FieldListCard = ({ field, isSelected, onSelectionChange, dataTestId = "", disabled }: FieldListCardProps) => (
  <Card
    dataTestId={`${dataTestId ? `${dataTestId}-` : ""}field-selection-card`}
    className={`field-selection-card${disabled ? " disabled" : ""}`}
    mixpanelText="field-card"
  >
    <div className="field-selection-card" onClick={onSelectionChange}>
      <div className="map-container">
        {/* @ts-expect-error need to convert this to TS */}
        <MapStatic field={field} location={field.location} marker />
      </div>
      <div className="field-details">
        <div className="name">
          <span className="paragraph-m-bold">{field.name}</span>
        </div>
        <div className="size">
          <span className="paragraph-s grey-600-text">
            <Icon iconName="klim/field-size" className="icon inline" />
            {formatNumber({ number: field.size })}ha
          </span>
        </div>
      </div>
      <div className="checkbox-container">
        <Checkbox checked={isSelected} disabled={disabled} />
      </div>
    </div>
  </Card>
);
